import { DatePickerField } from 'Shared/form/DatePickerField';
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    row: PropTypes.shape({
        original: PropTypes.shape({
            medicationId: PropTypes.string.isRequired,
        }),
        value: PropTypes.string,
    }).isRequired,
};

const defaultProps = {};

function RowDatePicker({ row }) {
    return (
        <DatePickerField
            fieldName={`medications.${row.original.medicationId}.statusDate`}
            required
        />
    );
}

RowDatePicker.propTypes = propTypes;
RowDatePicker.defaultProps = defaultProps;

export default RowDatePicker;
